import { __awaiter } from "tslib";
import { findAppDefinitionById } from '@office-start/m365-apps-service';
export const getDialogType = ({ appId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const appDefinition = yield findAppDefinitionById(appId);
    if ((appDefinition === null || appDefinition === void 0 ? void 0 : appDefinition.acquisitionState) === 'NeedsConsentForUpgrade') {
        return 'UPGRADE';
    }
    return 'INSTALL';
});
//# sourceMappingURL=getDialogType.js.map